import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { BaseDataReducerV2InitialState, basedDataReducerV2 } from 'redux/base-reducer-v2';

import { IEecsProduct, IEecsProductModal } from '../types/eecs-products.types';

export interface EecsProductsInitialState extends BaseDataReducerV2InitialState<IEecsProduct> {
  selectedProduct: IEecsProduct | null;
  isNeedSaveOrder: boolean;
  currentModal: IEecsProductModal | null;
}

const { initialState, AC, reducer, thunks } = basedDataReducerV2<IEecsProduct, EecsProductsInitialState>(
  'eecs-products',
);

export const eecsProductsInitialState: EecsProductsInitialState = {
  ...initialState,
  perPage: 100,
  selectedProduct: null,
  isNeedSaveOrder: false,
  currentModal: null,
};

export const eecsProducts = createSlice({
  name: 'eecsProducts',
  initialState: eecsProductsInitialState,
  reducers: {
    setSelectedProduct(state, action: PayloadAction<IEecsProduct | null>) {
      state.selectedProduct = action.payload;
    },
    setEecsProducts(state, action: PayloadAction<IEecsProduct[]>) {
      state.items = action.payload;
    },
    setEecsProductModal(state, action: PayloadAction<IEecsProductModal | null>) {
      state.currentModal = action.payload;
    },
    setIsNeedSaveOrder(state, action: PayloadAction<boolean>) {
      state.isNeedSaveOrder = action.payload;
    },
    clearState(state) {
      state = eecsProductsInitialState;
      return state;
    },
  },
  extraReducers: (builder) => {
    builder.addDefaultCase((state, action) => {
      return reducer(state as EecsProductsInitialState, action);
    });
  },
});

export const EecsProductsAC = AC;
export const onEecsProductsSort = thunks.onSort;
export const onEecsProductsFilter = thunks.onFilter;
export const clearEecsProductsFilters = AC.clearFilters;
export const setEecsProductsCurrentPage = AC.setCurrentPage;

export const { setSelectedProduct, setEecsProductModal, clearState, setEecsProducts, setIsNeedSaveOrder } =
  eecsProducts.actions;
